import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { translate } from 'translations/translator';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import ModalsTranslationVariant from 'translations/variants/modals';
const getTranslation = (key: ModalsTranslationVariant, options?) =>
  translate('modals', key, options);

type Props = {
  handleUnassign: () => void;
  started: number;
  completed: number;
};

export const UnassignLessonModal: React.FC<Props> = ({ handleUnassign, completed, started }) => {
  const [, { closeModal }] = useModal();
  const classes = useStyles();

  const handleUnassignLesson = () => {
    handleUnassign();
    closeModal();
  };

  return (
    <Container className={classes.container}>
      <Typography variant="h6" style={{ paddingTop: '24px', textAlign: 'center' }}>
        {getTranslation(ModalsTranslationVariant.areYouSureUnassign)}
      </Typography>
      <Box>
        {completed || started ? (
          <Typography>
            {getTranslation(ModalsTranslationVariant.unassignDetails, { completed, started })}
          </Typography>
        ) : null}
      </Box>
      <Box display="flex" className={classes.spaced}>
        <HwtButton onClick={closeModal} variant="outlined" style={{ marginBottom: '15px' }}>
          {getTranslation(ModalsTranslationVariant.cancel)}
        </HwtButton>
        <HwtButton variant="contained" color="secondary" onClick={handleUnassignLesson}>
          {getTranslation(ModalsTranslationVariant.yesUnassign)}
        </HwtButton>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    height: '251px',
    width: '616px !important',
    backgroundColor: '#fff',
    display: 'flex !important',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  spaced: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  font: {
    fontSize: '12px'
  }
}));
